import { useFragment } from '@apollo/client/react';
import { isEmpty } from 'lodash';

import { createRequiredContext } from 'src/context/createRequiredContext';
import { BeneficiaryFields } from 'src/graphql/actions/escrow/escrowBeneficiary.fragment';
import { AgreementFormEnum, type IBeneficiary } from 'src/graphql/schema';

const [useBeneficiaryContext, BeneficiaryContext] = createRequiredContext<{
  beneficiary: IBeneficiary | null;
  escrowId: string;
  agreementType: AgreementFormEnum;
  canCreateBeneficiary: boolean;
}>();

type Props = {
  beneficiaryId: string;
  escrowId: string;
  agreementType: AgreementFormEnum;
  canCreateBeneficiary: boolean;
};

const BeneficiaryContextProvider = ({
  beneficiaryId,
  escrowId,
  agreementType,
  canCreateBeneficiary,
  children,
}: React.PropsWithChildren<Props>) => {
  const { data } = useFragment<IBeneficiary>({
    fragment: BeneficiaryFields,
    fragmentName: 'BeneficiaryFields',
    from: {
      __typename: 'Beneficiary',
      id: beneficiaryId || '',
    },
  });

  const value = {
    beneficiary: isEmpty(data) ? null : (data as IBeneficiary),
    escrowId,
    agreementType,
    canCreateBeneficiary,
  };

  return <BeneficiaryContext value={value}>{children}</BeneficiaryContext>;
};

export { useBeneficiaryContext, BeneficiaryContextProvider };
